/* =====================================================================
   Çekirdek hesaplama — kanun yoluna başvuru son günü + kesinleşme tarihi.
   "kesinlesme.html" çekirdeğinden taşındı. SAF: dinî bayram kümesini
   (diniSet) ve ek bayram listesini parametre olarak alır, global okumaz.
   ===================================================================== */

import { addDays, ilkIsGunu, parseIso, sonGunHesapla } from './isGunuHesap';
import { adliTatilUygula } from './adliTatil';
import { DINI_KAPSAM } from './diniBayramlar';

export { sonGunHesapla };

/**
 * Tebliğ tarihinden başvuru son günü ve kesinleşme tarihini hesaplar.
 * diniSet: diniSetKur(ayar.ekBayramlar) ile kurulan etkin dinî bayram kümesi.
 * adliTatil: 'kapali' | 'hmk' | 'cmk' (rejim) — uzatma öncesi son güne adli tatil kuralını uygular.
 */
export function hesapla(tebligIso, sure, birim, diniSet, adliTatil = 'kapali') {
  const baslangic = addDays(tebligIso, 1);            // ertesi gün (1. gün)
  const hamSonGun = sonGunHesapla(tebligIso, sure, birim);
  // Adli tatil (varsa) son günü taşır; sonra normal hafta sonu/tatil yuvarlaması yapılır.
  const at = adliTatilUygula(hamSonGun, baslangic, sure, birim, adliTatil);
  const { tarih: sonItiraz, atlananlar } = ilkIsGunu(at.sonGun, diniSet);
  const kesinlesme = addDays(sonItiraz, 1);           // süre bitti → ertesi gün kesinleşir
  return {
    baslangic,
    hamSonGun,
    adliSonGun: at.sonGun,
    sonItiraz,
    kesinlesme,
    atlananlar,
    adliTatil: { rejim: adliTatil, uygulandi: at.uygulandi, tur: at.tur, oncekiSonGun: hamSonGun },
  };
}

/* Tebliğ–kesinleşme aralığındaki yıllardan, dinî bayram verisi EKSİK olanları döndürür.
   Sistemdeki yıllar (DINI_KAPSAM) tam kapsanmış sayılır. Kapsam dışı bir yıl ancak HEM
   Ramazan HEM Kurban kullanıcı tarafından girilmişse tamdır; biri eksikse uyarıya girer.
   Dönüş: [{ yil, eksik: ['Ramazan Bayramı', 'Kurban Bayramı'] }, ...] */
export function kapsamUyarisi(tebligIso, kesinIso, ekBayramlar = []) {
  const y1 = parseIso(tebligIso).getFullYear();
  const y2 = parseIso(kesinIso).getFullYear();
  const sonuc = [];
  for (let y = y1; y <= y2; y++) {
    if (y >= DINI_KAPSAM.min && y <= DINI_KAPSAM.max) continue; // sistemde tam tanımlı
    const turler = ekBayramlar
      .filter((b) => parseIso(b.ilkGun).getFullYear() === y)
      .map((b) => b.tip);
    const eksik = [];
    if (!turler.includes('ramazan')) eksik.push('Ramazan Bayramı');
    if (!turler.includes('kurban')) eksik.push('Kurban Bayramı');
    if (eksik.length) sonuc.push({ yil: y, eksik });
  }
  return sonuc;
}
